// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DropdownMenu from './DropdownMenu';

const StyledDropdownMenu = styled(DropdownMenu)``;

const Decoration = styled.div`
  margin: 0 12px;
  width: calc(100% - 24px);
  height: 2px;
  background-color: ${props => props.theme.colors.primary.magenta};
`;

const Span = styled.span`
  padding: 0 10px 2px;
  border-radius: 10px;
  border: 1px solid ${props => props.theme.colors.primary.magenta};
  background-color: ${props => props.theme.colors.primary.magenta};
  color: ${props => props.theme.colors.neutral.white};
`;

const ListItem = styled.li`
  margin: 6px 0 11px;
  font-size: 14px;
  list-style: none;
  position: ${props => (props.small ? 'relative' : 'static')};
  overflow: ${props => (props.small ? 'inherit' : 'hidden')};
  flex-grow: 0;
  flex-shrink: 1;

  &:hover {
    ${StyledDropdownMenu} {
      display: block;
    }

    ${Span} {
      background-color: ${props => props.theme.colors.neutral.white};
      color: ${props => props.theme.colors.primary.magenta};
    }
  }

  &:not(:hover) {
    ${Decoration} {
      background-color: transparent;
    }
  }

  :last-child {
    a {
      padding-right: 0;
    }
  }
`;

const Link = styled.a`
  padding: 8px 12px;
  text-decoration: none;
  color: ${props => props.theme.colors.neutral.currysBlack};
  display: block;
  white-space: nowrap;
`;

const NavigationItem = ({
  label, nav, link, small, maxWidth, ...rest
}) => (
  <ListItem
    // @ts-ignore
    small={small}
    {...rest}
  >
    <Link href={link}>{small ? <Span>{label}</Span> : label}</Link>
    {!small && <Decoration />}
    {nav?.length ? (
      <StyledDropdownMenu
        navigationData={nav}
        small={small}
        maxWidth={maxWidth}
      />
    ) : null}
  </ListItem>
);

NavigationItem.propTypes = {
  label: PropTypes.string,
  link: PropTypes.string,
  nav: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object])
  ),
  small: PropTypes.bool,
  maxWidth: PropTypes.string
};

NavigationItem.defaultProps = {
  label: null,
  link: null,
  nav: null,
  small: false,
  maxWidth: '1267px'
};

export default NavigationItem;
